<!-- TOAST ALERT -->
<p-toast key="tst" [style]="{marginTop: '70px'}"></p-toast>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<!-- USER CARD -->
<section class="churchRegister">
    <!-- FORM REGISTER -->
    <div class="card p-col-12 p-m-2">

        <!-- BACK BUTTON -->
        <p-toolbar styleClass="p-mb-4">
            <ng-template pTemplate="left">
                <button pButton pRipple label="{{lbl_go_Back}}" icon="pi pi-chevron-left"
                    class="p-button-warning p-mr-2" (click)="goBack()"></button>
            </ng-template>
        </p-toolbar>


        <!-- TITTLE -->
        <h5 class="churchRegisterForm__title--normal">{{lbl_churchs_chapels_parish}}</h5>

        <form [formGroup]="churchRegisterForm" class=" p-fluid p-formgrid p-grid">

            <div class="p-col-12 p-md-6">

                <div class="p-field p-col-12 p-md-12">
                    <h5>{{lbl_church_name}}</h5>
                </div>

                <!-- Input NAME -->
                <div class="p-field p-col-12 p-md-12">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                            <i class="pi  pi-pencil"></i>
                        </span>
                        <span class="p-float-label">
                            <input tabIndex="2" id="nameChurchInput" formControlName="nameChurch" maxlength="50"  type="text"
                                aria-describedby="current-help" pInputText />
                            <label htmlFor="nameChurchInput">{{lbl_name}}<span
                                    *ngIf="!churchRegisterForm.controls['nameChurch'].value" style="color:red">
                                    (*)</span></label>
                        </span>
                    </div>
                </div>
                <!-- Input short NAME -->
                <div class="p-field p-col-12 p-md-12">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                            <i class="pi  pi-pencil"></i>
                        </span>
                        <span class="p-float-label">
                            <input tabIndex="2" maxlength="15" id="shortName" formControlName="shortName" type="text"
                                aria-describedby="current-help" pInputText />
                            <label htmlFor="shortName">{{lbl_short_name}}<span
                                    *ngIf="!churchRegisterForm.controls['shortName'].value" style="color:red">
                                    (*)</span></label>
                        </span>
                    </div>
                </div>

                <!-- Input church type-->
                <div class="p-field p-col-12 p-md-12">
                    <span class="p-float-label">
                        <p-dropdown id="typeInput" formControlName="type" type="email" aria-describedby="current-help"
                            [options]="lstTypesChurch" [(ngModel)]="selectedTypeChurch" placeholder="_"
                            optionLabel="descrip"></p-dropdown>
                        <label htmlFor="typeInput">{{lbl_type}}<span *ngIf="!churchRegisterForm.controls['type'].value"
                                style="color:red"> (*)</span></label>
                    </span>

                </div>

                <!-- Input PHONE NUMBER -->
                <div class="p-field p-col-12 p-md-12">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                            <i class="pi  pi-phone"></i>
                        </span>
                        <span class="p-float-label">
                            <input tabIndex="6" id="phoneNumberInput" maxlength="20" formControlName="phoneNumber" type="text"
                                aria-describedby="current-help" pInputText />
                            <label htmlFor="phoneNumberInput">{{lbl_telephones_number}}</label>
                        </span>
                    </div>

                </div>

                <!-- Input COMMENTS -->
                <div class="p-field p-col-12 p-md-12">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                            <i class="pi  pi-comments"></i>
                        </span>
                        <span class="p-float-label">
                            <textarea rows="4" cols="30" pInputTextarea tabIndex="7" id="commentsInput"
                                formControlName="comments" maxlength="50" type="text" aria-describedby="current-help"
                                pInputText ></textarea>
                            <label htmlFor="commentsInput">{{lbl_comments}}</label>
                        </span>
                    </div>

                </div>
            </div>

            <div class="p-col-12 p-md-6 ">

                <div class="p-field p-col-12 p-md-12">
                    <h5>{{lbl_address}}</h5>
                </div>
                <!-- Input Country -->
                <div class="p-field p-col-12 p-md-12">

                    <span class="p-float-label">
                        <p-dropdown id="stateDptoProvinceInput" formControlName="country" type="email"
                            aria-describedby="current-help" [options]="countries" [(ngModel)]="selectedCountry"
                            optionLabel="descrip" class="test" [disabled]="true"></p-dropdown>
                        <label htmlFor="stateDptoProvinceInput">{{lbl_country}}<span
                                *ngIf="!churchRegisterForm.controls['country'].value" style="color:red"> (*)</span>
                        </label>
                    </span>


                </div>
                <!-- State Dpto-->
                <div class="p-field p-col-12 p-md-12">

                    <span class="p-float-label">
                        <p-dropdown id="stateDptoProvinceInput" formControlName="stateDptoProvince" type="email"
                            aria-describedby="current-help" [options]="listState" [(ngModel)]="selectedState"
                            optionLabel="descrip" class="test"></p-dropdown>
                        <label htmlFor="stateDptoProvinceInput">{{lbl_state}}<span
                                *ngIf="!churchRegisterForm.controls['stateDptoProvince'].value" style="color:red">
                                (*)</span>
                        </label>
                    </span>


                </div>

                <!-- Input City -->
                <div class="p-field p-col-12 p-md-12">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                            <i class="pi  pi-building"></i>
                        </span>
                        <span class="p-float-label">
                            <input tabIndex="1" id="countryInput" formControlName="city" type="text"
                                aria-describedby="current-help" maxlength="40" pInputText />
                            <label htmlFor="countryInput">{{lbl_city}}<span
                                    *ngIf="!churchRegisterForm.controls['city'].value" style="color:red">
                                    (*)</span></label>
                        </span>
                    </div>

                </div>

                <!-- Input DOWNTOWN -->
                <div class="p-field p-col-12 p-md-12">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                            <i class="pi  pi-home"></i>
                        </span>
                        <span class="p-float-label">
                            <input tabIndex="3" id="downtownInput" maxlength="30"  formControlName="downtown" type="text"
                                aria-describedby="current-help" pInputText />
                            <label htmlFor="downtownInput">{{lbl_neightborhood}}<span
                                    *ngIf="!churchRegisterForm.controls['downtown'].value" style="color:red">
                                    (*)</span></label>
                        </span>
                    </div>

                </div>

                <!-- Input STRET NUMBER -->
                <div class="p-field p-col-12 p-md-12">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                            <i class="pi  pi-hashtag"></i>
                        </span>
                        <span class="p-float-label">
                            <input tabIndex="4" id="streetNumberInput" maxlength="50" formControlName="streetNumber" type="text"
                                aria-describedby="current-help" pInputText />
                            <label htmlFor="streetNumberInput">{{lbl_street_and_number}}<span
                                    *ngIf="!churchRegisterForm.controls['streetNumber'].value" style="color:red">
                                    (*)</span></label>
                        </span>
                    </div>

                </div>

                <!-- Input POSTAL CODE -->
                <div class="p-field p-col-12 p-md-12">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                            <i class="pi  pi-map"></i>
                        </span>
                        <span class="p-float-label">
                            <input tabIndex="5" id="postalCodeInput" maxlength="10" formControlName="postalCode" type="text"
                                aria-describedby="current-help" pInputText />
                            <label htmlFor="postalCodeInput">{{lbl_zip_code}}<span
                                    *ngIf="!churchRegisterForm.controls['postalCode'].value" style="color:red">
                                    (*)</span></label>
                        </span>
                    </div>

                </div>
            </div>

            <!-- Space  -->
            <div class="p-field p-col-12 p-md-4"></div>
            <!-- Space  -->
            <div class="p-field p-col-12 p-md-4"></div>
            <!-- Button -->
            <div class="m-2 p-field p-col-12 p-xl-2 p-lg-2 p-g-2 p-md-2">
                <div class="ui-float-label">
                    <button [disabled]="button_save" tabIndex="8" pButton pRipple type="button" icon="pi pi-plus"
                        label="{{lbl_save}}" class="p-button-raised p-button-success"
                        (keyup.enter)="registerChurch($event)" (click)="registerChurch($event)"></button>
                </div>
            </div>
            <!-- Button -->
            <div class="m-2 p-field p-col-12 p-xl-2 p-lg-2 p-g-2 p-md-2" style="padding-right: 1.3%;">
                <div class="ui-float-label">
                    <button [disabled]="button_save" pButton pRipple type="button" icon="pi pi-trash"
                        label="{{lbl_delete_record}}" class="p-button-raised p-button-danger"
                        (keyup.enter)="deleteChurch($event)" (click)="deleteChurch($event)"></button>
                </div>
            </div>
        </form>
    </div>
</section>